import React, { useState, useEffect } from "react";
import { networkMemberAPI } from "../../services/AffiliatePartnerPortal/networklistAPI";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";

const AddNetworkModal = ({ isOpen, onClose, onSave }) => {
  const { user } = useAuth();

  const initialForm = {
    fullName: "",
    mobile: "",
    workType: "",
    work: "",
    age: "",
    address: "",
    relationType: "",
  };

  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  // Reset form every time modal is opened
  useEffect(() => {
    if (isOpen) {
      setFormData(initialForm);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!formData.fullName || !formData.mobile) {
      toast.error("Full name and Mobile are required");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
        createdBy: user?.id,
        createdByRole: user?.role,
      };

      const response = await networkMemberAPI.create(payload);

      // toast.success("Network member added successfully!");
      if (onSave) onSave(response.data.data); // ⬅️ pass the new member to parent

      onClose(); // close modal
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to add member");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/60 z-50">
      <div className="bg-[#1e1e1e] rounded-lg shadow-lg w-full max-w-lg p-6">
        <h2 className="text-xl font-semibold text-white mb-4">
          Add Network Member
        </h2>

        <div className="space-y-4">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-md bg-[#131313] border border-[#333333] text-white"
          />

          <input
            type="text"
            name="mobile"
            placeholder="Mobile Number (WhatsApp)"
            value={formData.mobile}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-md bg-[#131313] border border-[#333333] text-white"
          />

          <select
            name="workType"
            value={formData.workType}
            onChange={handleChange}
            className="w-full p-2 bg-[#131313] border border-[#333333] rounded text-[#AAAAAA] appearance-none"
          >
            <option value="">Select Work Type</option>
            <option value="Salaried">Salaried</option>
            <option value="Self employed">Self employed</option>
            <option value="Business">Business</option>
            <option value="Professional">Professional</option>
            <option value="Organisation">Organisation</option>
          </select>

          <input
            type="text"
            name="work"
            placeholder="Work"
            value={formData.work}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-md bg-[#131313] border border-[#333333] text-white"
          />

          <input
            type="number"
            name="age"
            placeholder="Age"
            value={formData.age}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-md bg-[#131313] border border-[#333333] text-white"
          />

          <textarea
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded-md bg-[#131313] border border-[#333333] text-white"
          />

          <select
            name="relationType"
            value={formData.relationType}
            onChange={handleChange}
            className="w-full p-2 bg-[#131313] border border-[#333333] rounded text-[#AAAAAA] appearance-none"
          >
            <option value="">Select Relation Type</option>
            <option value="Friends">Friends</option>
            <option value="Colleagues">Colleagues</option>
            <option value="Family Member">Family Member</option>
            <option value="Relatives">Relatives</option>
          </select>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-600 text-white hover:bg-gray-700"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={loading}
            className="px-4 py-2 rounded-md bg-[#FFCA20] text-black font-semibold disabled:opacity-50"
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNetworkModal;
